export default __webpack_public_path__ + "static/media/home-vertical-portfolio-img-01.3e5cf2d2.jpg";